/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { NotificationsControllerGetMyNotificationsQueryResponse, NotificationsControllerGetMyNotificationsQueryParams, NotificationsControllerGetMyNotifications401, NotificationsControllerGetMyNotifications403 } from "../../models/notificationsController/NotificationsControllerGetMyNotifications";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { notificationsControllerGetMyNotifications } from "../../clients/notificationsService/notificationsControllerGetMyNotifications";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const notificationsControllerGetMyNotificationsQueryKey = (params: NotificationsControllerGetMyNotificationsQueryParams = {}) => [{
  url: '/api/v1/notifications'
}, ...(params ? [params] : [])] as const;
export type NotificationsControllerGetMyNotificationsQueryKey = ReturnType<typeof notificationsControllerGetMyNotificationsQueryKey>;
export function notificationsControllerGetMyNotificationsQueryOptions(params?: NotificationsControllerGetMyNotificationsQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = notificationsControllerGetMyNotificationsQueryKey(params);
  return queryOptions<NotificationsControllerGetMyNotificationsQueryResponse, ResponseErrorConfig<NotificationsControllerGetMyNotifications401 | NotificationsControllerGetMyNotifications403>, NotificationsControllerGetMyNotificationsQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return notificationsControllerGetMyNotifications(params, config);
    }
  });
}

/**
 * @description Returns notifications grouped into today, yesterday, this week, and older. Excludes soft-deleted notifications.
 * @summary Get all notifications for current user grouped by day
 * {@link /api/v1/notifications}
 */
export function useNotificationsControllerGetMyNotifications<TData = NotificationsControllerGetMyNotificationsQueryResponse, TQueryData = NotificationsControllerGetMyNotificationsQueryResponse, TQueryKey extends QueryKey = NotificationsControllerGetMyNotificationsQueryKey>(params?: NotificationsControllerGetMyNotificationsQueryParams, options: {
  query?: Partial<QueryObserverOptions<NotificationsControllerGetMyNotificationsQueryResponse, ResponseErrorConfig<NotificationsControllerGetMyNotifications401 | NotificationsControllerGetMyNotifications403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? notificationsControllerGetMyNotificationsQueryKey(params);
  const query = useQuery({
    ...notificationsControllerGetMyNotificationsQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<NotificationsControllerGetMyNotifications401 | NotificationsControllerGetMyNotifications403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}